import { Typography, Stack, useTheme } from "@mui/material";
import { NextActionDto } from "@/modules/lead-page/dtos";
import { format, isBefore, parseISO } from "date-fns";
import UserNameTag from "@/modules/lead-page/new/components/activity/user-name-tag";
import { useMemo } from "react";
import CircularCheckbox from "@/modules/common/components/ui-kit/inputs/circular-checkbox";
import { parseLinks } from "@/modules/common/utils/parse-links";

interface TaskProps {
  action: NextActionDto;
  nextActionId?: string | number;
  handleMarkComplete: (uid: string) => void;
}
const Task = ({ action, nextActionId, handleMarkComplete }: TaskProps) => {
  const theme = useTheme();

  const isChecked = useMemo(() => {
    return nextActionId === action.uid;
  }, [nextActionId, action.uid]);

  const isPast = isBefore(new Date(action.actionTime), new Date());

  return (
    <Stack
      direction="row"
      spacing={theme.nawy.spacing.xs}
      alignItems="start"
      alignSelf="stretch"
      padding={0}
    >
      <CircularCheckbox
        checked={isChecked}
        onChange={() => handleMarkComplete(action.uid)}
        size={20}
      />

      <Stack direction="column" sx={{ minWidth: 0, overflow: "hidden" }}>
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.md.regular,
            color: theme.nawy.colors.semantic.text.primary,
            whiteSpace: "pre-line",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {parseLinks(action.description)}
        </Typography>

        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.sm.regular,
            color: isPast
              ? theme.nawy.colors.semantic.text.extension.negative
              : theme.nawy.colors.semantic.text.tertiary,
          }}
        >
          {format(parseISO(action.actionTime), "d MMM, h:mm a")}
        </Typography>

        {action?.creator?.name && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={theme.nawy.spacing.xs}
          >
            <Typography
              sx={{
                ...theme.nawy.typography.english.variants.body.sm.regular,
                color: theme.nawy.colors.semantic.text.tertiary,
                whiteSpace: "nowrap",
              }}
            >
              Added by
            </Typography>

            <UserNameTag
              name={action.creator.name || ""}
              color={action.creator.color}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default Task;

